var chunkMapping = {
	"webpack_container_remote_wizardGenerator_Widget": [
		"webpack/container/remote/wizardGenerator/Widget"
	],
	"webpack_container_remote_poiManagement_App": [
		"webpack/container/remote/poiManagement/App"
	],
	"webpack_container_remote_dashboardGeneratorVisualizer_App": [
		"webpack/container/remote/dashboardGeneratorVisualizer/App"
	],
	"webpack_container_remote_user_management_frontend_App": [
		"webpack/container/remote/user_management_frontend/App"
	],
	"webpack_container_remote_wizardGenerator_App": [
		"webpack/container/remote/wizardGenerator/App"
	],
	"webpack_container_remote_dashboardGeneratorVisualizer_UpsellWidget": [
		"webpack/container/remote/dashboardGeneratorVisualizer/UpsellWidget"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/wizardGenerator/Widget": [
		"default",
		"./Widget",
		"webpack/container/reference/wizardGenerator"
	],
	"webpack/container/remote/poiManagement/App": [
		"default",
		"./App",
		"webpack/container/reference/poiManagement"
	],
	"webpack/container/remote/dashboardGeneratorVisualizer/App": [
		"default",
		"./App",
		"webpack/container/reference/dashboardGeneratorVisualizer"
	],
	"webpack/container/remote/user_management_frontend/App": [
		"default",
		"./App",
		"webpack/container/reference/user_management_frontend"
	],
	"webpack/container/remote/wizardGenerator/App": [
		"default",
		"./App",
		"webpack/container/reference/wizardGenerator"
	],
	"webpack/container/remote/dashboardGeneratorVisualizer/UpsellWidget": [
		"default",
		"./UpsellWidget",
		"webpack/container/reference/dashboardGeneratorVisualizer"
	]
};
var idToRemoteMap = {
	"webpack/container/remote/wizardGenerator/Widget": [
		{
			"externalType": "script",
			"name": "wizardGenerator"
		}
	],
	"webpack/container/remote/poiManagement/App": [
		{
			"externalType": "script",
			"name": "poiManagement"
		}
	],
	"webpack/container/remote/dashboardGeneratorVisualizer/App": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer"
		}
	],
	"webpack/container/remote/user_management_frontend/App": [
		{
			"externalType": "script",
			"name": "user_management_frontend"
		}
	],
	"webpack/container/remote/wizardGenerator/App": [
		{
			"externalType": "script",
			"name": "wizardGenerator"
		}
	],
	"webpack/container/remote/dashboardGeneratorVisualizer/UpsellWidget": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"webpack/container/remote/wizardGenerator/Widget": {
		"shareScope": "default",
		"name": "./Widget",
		"externalModuleId": "webpack/container/reference/wizardGenerator",
		"remoteName": "wizardGenerator"
	},
	"webpack/container/remote/poiManagement/App": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": "webpack/container/reference/poiManagement",
		"remoteName": "poiManagement"
	},
	"webpack/container/remote/dashboardGeneratorVisualizer/App": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": "webpack/container/reference/dashboardGeneratorVisualizer",
		"remoteName": "dashboardGeneratorVisualizer"
	},
	"webpack/container/remote/user_management_frontend/App": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": "webpack/container/reference/user_management_frontend",
		"remoteName": "user_management_frontend"
	},
	"webpack/container/remote/wizardGenerator/App": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": "webpack/container/reference/wizardGenerator",
		"remoteName": "wizardGenerator"
	},
	"webpack/container/remote/dashboardGeneratorVisualizer/UpsellWidget": {
		"shareScope": "default",
		"name": "./UpsellWidget",
		"externalModuleId": "webpack/container/reference/dashboardGeneratorVisualizer",
		"remoteName": "dashboardGeneratorVisualizer"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}